import React from "react";
import ReservationsTransactions from "../../../component/Reservations/ReservationsTransactions";

const ReservationsTransactionsScreen = () => {
  return <div><ReservationsTransactions /></div>;
};

export default ReservationsTransactionsScreen;
